/** Client-safe links to payment-gated scheduling (never embed raw Calendly URLs). */

export function paidCalendlySchedulePath(input: {
  sessionId?: string
  quoteRequestId?: string
  email?: string
}): string {
  const params = new URLSearchParams()
  if (input.sessionId?.trim()) params.set('session_id', input.sessionId.trim())
  if (input.quoteRequestId?.trim()) params.set('quote', input.quoteRequestId.trim())
  if (input.email?.trim()) params.set('email', input.email.trim().toLowerCase())
  const qs = params.toString()
  return qs ? `/api/calendly-schedule?${qs}` : '/api/calendly-schedule'
}
